import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { useStyles } from './ToggleButton.styled';
import { useTranslation } from 'react-i18next';
  
const AntSwitch = withStyles((theme) => ({
    root: {
        width: 24,
        height: 14,
        padding: 0,
        display: 'flex',
        fontFamily: 'AvenirNextWorld Regular',
        color: '#140F4B',
        fontSize: '14px',

        '& .MuiTypography-body1': {
            display: 'flex',
            fontFamily: 'AvenirNextWorld Regular',
            fontSize: '14px',
            color: '#140F4B',
            flexWrap: 'nowrap',
            whiteSpace: 'nowrap',
        },
    },
    switchBase: {
        padding: 3,
        color: '#140F4B',
        '&$checked': {
            transform: 'translateX(12px)',
            color: '#ffffff',
            '& + $track': {
                opacity: 1,
                backgroundColor: '#1010EB',
                borderColor: theme.palette.primary.main,
            },
        },
    },
    thumb: {
        width: 8,
        height: 8,
        boxShadow: 'none',
    },
    track: {
        border: '1px solid #140F4B',
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
}))(Switch);

const ToggleButton = (props) => {
    const classes = useStyles();
    const { checked, onChange } = props;
    const { t } = useTranslation();
    return (
        <Typography
            component="div"
            classes={{ root: classes.root }}
            style={{
                marginLeft:
                    (props.label === t('calendar.actionPanel.myDeniedOverrides') &&
                    props.isMobileView ) &&
                    '11.5rem',
                marginTop:
                    (props.label === t('calendar.actionPanel.myDeniedOverrides') &&
                    props.isMobileView ) &&
                    '-2rem',
            }}
        >
            <Grid
                component="label"
                container
                alignItems="center"
                spacing={1}
                classes={{ root: classes.root }}
            >
                <Grid item>
                    <AntSwitch
                        checked={checked}
                        onChange={onChange}
                        name="checked"
                    />
                </Grid>
                <Grid item>{props.label}</Grid>
            </Grid>
        </Typography>
    );
};

export default ToggleButton;
